import uk.co.nickthecoder.kyd.*

class CavernQuest(game: Game) : Management(game) {

    var blastsPerDynamite = 25

    var maxBlasts = 1000

    var friendly = false

    var monstersGetStuck = true

    private val snapping = GridSnapping(gridSize)

    init {
        instance = this
    }

    override fun positionSnapping(stage: Stage): Snapping {
        return if (stage.name == "glass") NoSnapping else snapping
    }

    companion object {
        lateinit var instance: CavernQuest
    }
}
